import React from 'react';
import style from './style.css';

const QuestLayout = props => <div className={style.questLayout}>{props.children}</div>;
export default QuestLayout;
